
document.addEventListener('DOMContentLoaded', function () {

    class YGCardSwiper extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.init();
        }

        init() {
            this.swiper = new Swiper(this.querySelector('.yg-swiper'), {
                pagination: {
                    el: '.swiper-pagination',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    260: {
                        slidesPerView: 1.1,
                        spaceBetween: 14,
                    },
                    550: {
                        slidesPerView: 1.2,
                        spaceBetween: 14,
                    },
                    700: {
                        slidesPerView: 1.1,
                        spaceBetween: 24,
                    },
                    1000: {
                        slidesPerView: 2.2,
                        spaceBetween: 24,
                    },
                },
                scrollbar: {
                    el: '.swiper-scrollbar',
                },
            });
        }
    }
    if (!window.customElements.get('yg-card-swiper')) {
        window.customElements.define('yg-card-swiper', YGCardSwiper);
    }
});

